import {
	FormControl,
	Grid,
	IconButton,
	Input,
	InputAdornment,
	InputLabel,
	List,
	ListItem,
	ListItemText,
	TextField,
} from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import axios from "axios";
import React, { useEffect, useState } from "react";
import config from "react-global-configuration";
import Backdrop from "../../Backdrop/Backdrop";
import Modal from "../../Modal/Modal";

const Vendedor = (props, ref) => {
	const [modalOpen, SetModalOpen] = useState(false);
	const [formData, SetFormData] = useState({});
	const [searchResults, SetSearchResults] = useState();
	const [searchResultsFilter, SetSearchResultsFilter] = useState();
	const [VendedorSelected, setVendedorSelected] = useState("");
	const [loading, SetLoading] = useState(false);

	useEffect(() => {
		SetLoading(true);
		axios
			.get(config.get("url_api") + "totvs/vendedor/lista")
			.then((response) => {
				if (response.data.success) {
					SetSearchResults(response.data.vendedores);
					SetSearchResultsFilter(response.data.vendedores);
				} else {
					SetSearchResults([]);
				}

				SetLoading(false);

				let data = [];
				const name = "COMERCIAL METALIFE PILATES";
				if (name !== "" && response.data.vendedores) {
					response.data.vendedores.forEach((item) => {
						if (
							item.cCodigo.indexOf(name) !== -1 ||
							item.cNome.toLowerCase().indexOf(name.toLowerCase()) !== -1
						) {
							data.push(item);
						}
					});
				} else {
					data = response.data.vendedores;
				}

				SetFormData({ name: name });
				SetSearchResultsFilter(data);
			})
			.catch((error) => {
				SetLoading(false);
			});
	}, []);

	const inputHandler = (Vendedor) => {
		setVendedorSelected(Vendedor.cNome);
		props.setFormData({
			...props.formData,
			cVendedor: Vendedor.cCodigo,
		});
		SetModalOpen(false);
	};

	const filtrarResultadosH = () => {
		filtrarResultados("COMERCIAL METALIFE PILATES");
	};
	const filtrarResultados = (name) => {
		let data = [];

		if (name !== "" && searchResults) {
			searchResults.forEach((item) => {
				if (
					item.cCodigo.indexOf(name) !== -1 ||
					item.cNome.toLowerCase().indexOf(name.toLowerCase()) !== -1
				) {
					data.push(item);
				}
			});
		} else {
			data = searchResults;
		}

		SetFormData({ name: name });
		SetSearchResultsFilter(data);
	};

	return (
		<React.Fragment>
			<FormControl fullWidth>
				<InputLabel htmlFor="standard-adornment-password">Vendedor</InputLabel>
				<Input
					id={"cVendedor"}
					type={"text"}
					value={VendedorSelected}
					margin="dense"
					error={VendedorSelected === ""}
					placeholder={"Selecione o vendedor"}
					required
					readOnly
					fullWidth
					endAdornment={
						<InputAdornment position="end">
							<IconButton onClick={(e) => SetModalOpen(true)}>
								<Edit />
							</IconButton>
						</InputAdornment>
					}
				/>
			</FormControl>

			{modalOpen && (
				<Backdrop>
					<Modal
						size="lg"
						title="Buscar vendedor"
						onCancel={() => {
							SetModalOpen(false);
						}}
						onCancelTopo
						onConfirmLabel="selecionar vendedor"
						saving={loading}
					>
						{/* {loading ? <AutorenewIcon className="spin" /> : ""} */}
						{!loading && searchResultsFilter && searchResults.length > 0 && (
							<React.Fragment>
								<Grid container spacing={3}>
									<Grid item md={6}>
										<TextField
											margin="dense"
											id="buscar"
											name="buscar"
											label="Buscar por"
											autoComplete="off"
											fullWidth
											autoFocus
											value={formData && formData.name ? formData.name : ""}
											onChange={(e) => filtrarResultados(e.target.value)}
										/>
										<List
											component="nav"
											aria-label="secondary mailbox folders"
										>
											<div className="addProductGroups__container">
												{searchResultsFilter.map((Vendedor) => {
													if (props.vendedorRemover !== Vendedor.cNome) {
														return (
															<ListItem
																button
																key={Vendedor.cCodigo}
																onClick={() => inputHandler(Vendedor)}
															>
																<ListItemText
																	primary={Vendedor.cNome}
																	secondary={Vendedor.cCodigo}
																/>
															</ListItem>
														);
													}
												})}
											</div>
										</List>
									</Grid>
									<Grid item md={6}>
										<h2>Regras para o vendedor</h2>
										<br />
										<h3>Vendas em até 2 vezes</h3>
										<p>COMERCIAL METALIFE PILATES</p>
										<h3>Pedidos Revenda</h3>
										<p>COMERCIAL METALIFE PILATES - REVENDA</p>
										<h3>Pedidos de Troca</h3>
										<p>COMERCIAL METALIFE PILATES - TROCA</p>
										<h3>Entrada + 11 parcelas</h3>
										<p>COMERCIAL METALIFE PILATES - COMPRA PROGRAMADA</p>
									</Grid>
								</Grid>
							</React.Fragment>
						)}
						{!loading && searchResults && searchResultsFilter.length === 0 && (
							<div>Nenhum vendedor encontrado.</div>
						)}
					</Modal>
				</Backdrop>
			)}
		</React.Fragment>
	);
};

export default Vendedor;
